import { defineStore } from 'pinia';
import { storeConfig } from '@/shared/storeConfig';
import type { UserLimits } from '@/types/UserLimits';

export const useUserLimitsStore = defineStore(
  'userLimits',
  () => {
    const loadingUserLimits = ref<boolean | number>(false);
    const userLimits = ref<UserLimits | null>(null);
    const userExceedTimeoutLimit = ref<boolean>(false);

    function setUserLimits(limits: UserLimits) {
      userLimits.value = limits;
    }

    function setUserExceedTimeoutLimit(value: boolean) {
      userExceedTimeoutLimit.value = value;
    }

    function $reset() {
      loadingUserLimits.value = false;
      userLimits.value = null;
      userExceedTimeoutLimit.value = false;
    }

    return {
      loadingUserLimits,
      userLimits,
      setUserLimits,
      userExceedTimeoutLimit,
      setUserExceedTimeoutLimit,
      $reset,
    };
  },

  storeConfig,
);
